import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
          <p className="mt-4 text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    // Preserve the original URL so the login page can send the user back
    // here after signing in (avoids the "refresh drops me on the dashboard"
    // trap). ``location`` is the full react-router location object
    // (pathname + search + hash), so query strings and hashes survive too.
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // Check if email is verified
  if (user.email_confirmed_at === null) {
    return <Navigate to="/verify-email" replace />;
  }

  return children;
};